const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS({ onReport: onPerfEntry });
      getFID({ onReport: onPerfEntry });
      getFCP({ onReport: onPerfEntry });
      getLCP({ onReport: onPerfEntry });
      getTTFB({ onReport: onPerfEntry });
    });
  }
};

export default reportWebVitals;